module.exports = __webpack_public_path__ + "static/media/previousArrow.851bd8fa.svg";